import React, { useEffect, useRef, useState } from "react";
import { ImagePlus, Trash2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/api";

export const LogoCard = ({ hasLogo, onChange }) => {
  const [src, setSrc] = useState(null);
  const [busy, setBusy] = useState(false);
  const input = useRef(null);
  useEffect(() => {
    if (!hasLogo) { setSrc(null); return; }
    api.get("/doc-templates/logo", { responseType: "blob" }).then((r) => setSrc(URL.createObjectURL(r.data))).catch(() => setSrc(null));
  }, [hasLogo]);
  const upload = async (f) => {
    if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData(); fd.append("file", f);
      await api.post("/doc-templates/logo", fd);
      toast.success("Logo enregistré pour tous vos documents"); onChange(true);
    } catch (e) { toast.error(e.response?.data?.detail || "Échec de l'envoi"); } finally { setBusy(false); }
  };
  const remove = async () => { await api.delete("/doc-templates/logo"); onChange(false); toast.success("Logo retiré"); };
  return (
    <div className="flex items-center gap-3 bg-white border border-brand-soft rounded-2xl p-3" data-testid="tpl-logo-card">
      <div className="w-20 h-12 rounded-lg bg-brand-softer grid place-items-center overflow-hidden">
        {src ? <img src={src} alt="Logo" className="max-w-full max-h-full object-contain" data-testid="tpl-logo-img" /> : <ImagePlus className="w-5 h-5 text-brand-green/40" />}
      </div>
      <div className="flex-1 text-xs text-brand-green/60">
        <p className="font-medium text-brand-greenDeep text-sm">Logo des documents</p>
        Remplace le logo de la fiche propriétaire dans l'en-tête de tous vos modèles.
      </div>
      <input ref={input} type="file" accept="image/png,image/jpeg" className="hidden" onChange={(e) => upload(e.target.files[0])} data-testid="tpl-logo-input" />
      <button type="button" onClick={() => input.current.click()} disabled={busy} className="px-3 py-1.5 rounded-full border border-brand-soft text-xs font-medium hover:bg-brand-softer" data-testid="tpl-logo-upload">
        {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : src ? "Changer" : "Ajouter"}
      </button>
      {src && <button type="button" onClick={remove} className="text-brand-green/40 hover:text-red-500" data-testid="tpl-logo-remove"><Trash2 className="w-4 h-4" /></button>}
    </div>
  );
};
